import stl from "./HeroArea.module.css";
import {useTranslation} from "@i18n";
import {CDN_LINK} from "@globalConfig";

const HeroArea = () => {
    const {t} = useTranslation(["web_city"]);
    return (
        <>
            <div className={stl.CHA_container}>
                <div className={stl.CHA_text}>
                    <p className={stl.subTitle}>{t("أوسع تشكيلة", {ns: "web_city"})}</p>
                    <p className={stl.title}>
                        {t("سيارات في السعودية", {ns: "web_city"})}
                    </p>
                    <p>{t("جديد أو مستعمل وحنا نوصلها لين عندك", {ns: "web_city"})}</p>
                </div>
                <img
                    src={CDN_LINK + `/assets/images/city/biggest_collection.webp`}
                    alt="biggest collection of cars image"
                    loading="eager"
                    width="510px"
                    height="280px"
                />
            </div>
        </>
    );
};

export default HeroArea;
